import axios from "axios";
import React, { useEffect, useState } from "react";
import { formatDate } from "../../utils/reportUtils";
import { useNavigate } from "react-router-dom";

const storedUser = JSON.parse(localStorage.getItem("user"));

const authHeader = {
  headers: {
    Authorization: `Bearer ${storedUser?.accessToken}`,
  },
};

const API = process.env.REACT_APP_BACKEND_URL;

const Snapshots = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uploads, setUploads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadSnapshots();
  }, []);

  const loadSnapshots = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(`${API}/report-upload/all`, authHeader);

      setUploads(response.data || []);
    } catch (e) {
      console.error(e);
      setError("Unable to load upload history.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page">
        <div className="ph">
          <div>
            <h1>Snapshots</h1>
            <p>Upload history for procurement reports.</p>
          </div>
        </div>

        <div className="card">
          <div className="empty">
            <strong>Loading snapshots...</strong>
            Please wait.
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page">
        <div className="ph">
          <div>
            <h1>Snapshots</h1>
            <p>Upload history for procurement reports.</p>
          </div>
        </div>

        <div className="note err">
          <b>Unable to load snapshots.</b>
          <br />
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="ph">
        <div>
          <h1>Snapshot history</h1>

          <p>
            Committed snapshots are never edited. Uploading again creates a new
            one, so any result can be reproduced.
          </p>
        </div>

        <button className="btn btn-o" onClick={() => navigate("/upload")}>
          New Upload
        </button>
      </div>

      <div className="card">
        <div className="tw">
          <table className="dt">
            <thead>
              <tr>
                <th>File name</th>
                <th>Created</th>
                <th>By</th>
                <th>MRP</th>
                <th>Stock</th>
                <th>PR</th>
                <th>PO</th>
              </tr>
            </thead>

            <tbody>
              {uploads.length > 0 ? (
                uploads.map((upload) => (
                  <tr key={upload.uploadId}>
                    <td>
                      <span className="mono">{upload.fileName || "—"}</span>
                    </td>

                    <td>
                      {upload.createdDate ? formatDate(upload.createdDate) : "—"}
                    </td>

                    <td>{upload.orgUserName || "—"}</td>

                    <td>{upload.mrpCount || "—"}</td>
                    <td>{upload.stockCount || "—"}</td>
                    <td>{upload.openPrCount || "—"}</td>
                    <td>{upload.openPoCount || "—"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="empty">
                    <strong>No snapshots found.</strong>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="note">
        <b>Upload history.</b> Each snapshot represents a procurement report
        upload for the current organization.
      </div>
    </div>
  );
};

export default Snapshots;
